module.exports = __webpack_public_path__ + "media/images/icons/copy-bba779948e682549a0770599298f9807.svg";